// Certificates data
export const certificatesData = [
  {
    id: 1,
    title: "Databricks Data Engineer Associate",
    issuingOrganization: "Databricks",
    issueDate: '2025-04-14',
    expiryDate: '2027-04-14',
    pdfPath: "/assets/certificates/databricks_data_engineer_associate.pdf",
    skills: ["Databricks", "Apache Spark", "Data Engineering", "Python", "SQL"],
    logoPath: "/assets/certificates/databricks_data_engineer_associate_logo.png",
    link: "https://credentials.databricks.com/35f34ef8-b490-402c-980a-2e536a89ddea#acc.4qIKiYCc",
    displayOrder: 2,
    isVisible: true
  },
  {
    id: 2,
    title: "Databricks Data Engineer Professional",
    issuingOrganization: "Databricks",
    issueDate: '2025-07-21',
    expiryDate: '2027-07-21',
    pdfPath: "/assets/certificates/databricks_data_engineer_professional.pdf",
    skills: ["Databricks", "Apache Spark", "Data Engineering", "Data Architecture", "Performance Optimization", "Python", "SQL", "Delta Lake"],
    logoPath: "/assets/certificates/databricks_data_engineer_professional_logo.png",
    link: "https://credentials.databricks.com/b9ecc3c6-8e34-490e-871e-88884fbc347c#acc.0KzBaZLv",
    displayOrder: 1,
    isVisible: true
  }
];

// Certificate-Activity relationships
export const certificateActivitiesData = [
  // Databricks certs related to current work activity (IT System- & Process-Consultant)
  { certificateId: 1, activityId: 7 },
  { certificateId: 2, activityId: 7 }
];
